
import axios from 'axios'
import config from 'config/config'
import * as TextProps from '../constants/text'
import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '../authConfig'
import { createBrowserHistory } from 'history'
import { makeURL, uniqueId } from '../components/Utils'

export const history = createBrowserHistory()
const systemInfo = JSON.parse(window.sessionStorage.getItem('systemInfo'))

const axiosClient = axios.create()
axiosClient.defaults.baseURL = makeURL(config.API_VERSION)
const audit = {
  source: systemInfo?.source || '',
  ipAddress: systemInfo?.ip || '',
  deviceId: systemInfo?.deviceId || '',
  sessionId: uniqueId()
}
axiosClient.defaults.headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Audit: JSON.stringify(audit)
}
axiosClient.defaults.timeout = 30000

axiosClient.defaults.withCredentials = true
axiosClient.interceptors.response.use((response) => {
  return response
}, (error) => {
  const originalRequest = error.config

  if ((error.response.status === 401) && !originalRequest.retry && error.response.data.code !== 'USRLKD' && error.response.data.code !== 'TKNINV') {
    originalRequest.retry = TextProps.VALUE_TRUE
    return getRefreshToken()
      .then(() => {
        const idToken = window.sessionStorage.getItem('id_token')
        const configuration = error.config
        configuration.headers.Authorization = idToken
        return new Promise((resolve, reject) => {
          axios
            .request(configuration)
            .then(response => {
              resolve(response)
            })
            .catch(resErr => {
              reject(resErr)
            })
        })
      })
      .catch(err => {
        Promise.reject(err)
      })
  }
  return Promise.reject(error)
}
)

export default axiosClient
function getRefreshToken () {
  return new Promise((resolve, reject) => {
    if (window.sessionStorage.getItem('id_token') != null) {
      try {
        const msalInstance = new PublicClientApplication(msalConfig)

        const currentAccount = window.sessionStorage.getItem('home_account')
        const silentRequest = {
          scopes: ['openid', msalConfig.auth.clientId],
          account: currentAccount
        }

        msalInstance.acquireTokenSilent(silentRequest).then((response) => {
          window.sessionStorage.setItem('id_token', 'Bearer ' + response.idToken)
        }).catch(async (error) => {
          if (error) {
            // fallback to interaction when silent call fails
            window.sessionStorage.setItem('is_Logout', TextProps.VALUE_TRUE)
            msalInstance.logoutRedirect()
          }
        })
      } catch (err) {
        console.log('Refresh token error', err)
      }
    }
  })
}
